import React, { useEffect, useState } from "react";
import "./Claims.css";
import layout from "../../assets/img/claims/layout.svg";
import { Container, Row, Col } from "react-bootstrap";
import ClaimTab from "./ClaimTab";
import GotCovered from "./GotCovered";
import ClaimOptions from "./ClaimOptions";
import ClaimsStatus from "./ClaimsStatus";
import ThinksRemember from "./ThinksRemember";
import ClaimContactUs from "./ClaimContactUs";

const Claims = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  return (
    <>
      <div className="py-5" style={{ ...styles.container }}>
        <Container style={{ maxWidth: "1350px", margin: "0 auto" }}>
          <Row
            className="align-items-center"
            style={{
              position: "relative",
              left: 0,
              maxWidth: "1350px",
              margin: "0 auto",
            }}
          >
            {/* Left Column: Text Content */}
            <Col lg={6}>
              <p
                style={{
                  color: "#17252E",
                  fontSize: "16px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    paddingBottom: "5px",
                  }}
                >
                  Claims Made Easy
                  <span
                    style={{
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -4,
                      height: "1.6px",
                      width: "70%",
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)",
                    }}
                  />
                </span>
              </p>

              <h2
                className="mt-2"
                style={{
                  color: "#17252E",
                  lineHeight: "1",
                  fontWeight: "bold",
                  fontSize:
                    responsiveStatus === "isDesktop"
                      ? "40px"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "40px"
                      : "24px",
                }}
              >
                The Easiest Way to File a Claim — Anytime!
              </h2>

              <p className="mb-4 text-secondary" style={{ marginTop: "2em" }}>
                Filing a claim has never been easier! Whether you're a customer
                or not, our streamlined process ensures quick and hassle-free
                claim submissions. Get started and let us handle the rest.
              </p>
            </Col>

            {/* Right Column: Image + Floating Cards */}
            <Col lg={6} className="position-relative mt-lg-0">
              <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <ClaimTab />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <GotCovered />
      <ClaimOptions responsiveStatus={responsiveStatus} />
      <ClaimsStatus responsiveStatus={responsiveStatus} />
      <ThinksRemember responsiveStatus={responsiveStatus} />
      <ClaimContactUs responsiveStatus={responsiveStatus} />
    </>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "400px",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "right",
  },
};

export default Claims;
